export function VerificaInativo(objetos: any[]) {

    let erros: string[] = [];

    for (const obj of objetos) {
        if (!obj || !obj.objeto) continue;
        const chaves = Object.keys(obj.objeto);
        chaves.forEach((chave) => {
            if (chave === 'ativo' && obj.objeto.ativo === 'N') {
                if (obj.nome === 'Forma de Cobrança' || obj.nome === 'Tabela de Preço') {
                    erros.push(`${obj.nome} está inativa`);
                } else {
                    erros.push(`${obj.nome} está inativo`)
                }
            }
        });
    }

    return erros;
}